module.exports = __webpack_public_path__ + "img/popup-2.37af528f.png";